<div class="dialogContainer">
  <div class="header">
    <h2>Change all line lead times</h2>
  </div>
  <div class="content">
    <select class="inputField" [(ngModel)]="selectedLeadTime">
      @for (leadTime of leadTimes; track leadTime) {
        <option [value]="leadTime.code">{{ leadTime.description }}</option>
      }
    </select>
  </div>
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="cancel()">Cancel</button>
      <button matButton="elevated" (click)="saveAndClose()">Save</button>
    </span>
  </div>
</div>
